import {
  getNameDescriptionTableColumn,
  getEnabledTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import {
  getSubscriptionProjectTableColumn,
  getSubscriptionBillingTypeTableColumn,
  getFrequencyTableColumn,
  getSubjectTableColumn,
  getBillScopeTableColumn,
  getNotifyTypeTableColumn,
  getPrepaidAmortizingColumn,
  getProjectSharingColumn,
} from '../utils/columns'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      getEnabledTableColumn(),
      getSubscriptionProjectTableColumn(),
      getSubscriptionBillingTypeTableColumn(),
      getBillScopeTableColumn({ vm: this }),
      getFrequencyTableColumn(),
      getNotifyTypeTableColumn(),
      getSubjectTableColumn(),
      getPrepaidAmortizingColumn(),
      getProjectSharingColumn(),
      getTimeTableColumn({ field: 'created_at', title: this.$t('common.createdAt') }),
    ]
  },
}
